module.exports = __webpack_public_path__ + "img/948976028.1b96fdde.jpg";